module.exports = __webpack_public_path__ + "static/champlain-logo-a54cd7178eebde3faa6d7076ba5a9cc3.png";